// `href` defaults to the current page URL; only valid in browser contexts.
export function getShotId(href: string = window.location.href): string | null {
  try {
    const url = new URL(href);
    const value = url.searchParams.get('shot');
    if (value === null || value === '') return null;
    return value;
  } catch {
    return null;
  }
}

export function markShotMode(): void {
  document.body.setAttribute('data-shot', '1');
}
